import React from 'react';
import { createPortal } from 'react-dom';
import { X } from 'lucide-react';
import { useTranslation } from 'react-i18next';

export default function Modal({ title, onClose, children, footer, size = '', style }) {
  const { i18n } = useTranslation();
  // v4.1: rendered at the end of <body>; inside a card with backdrop-filter / transform a "fixed" overlay is
  // trapped in that card (it showed up cut off inside the suppliers card, without its Save button)
  return createPortal(
    <div className="modal-overlay" dir={i18n.language === 'fa' ? 'rtl' : 'ltr'} onClick={onClose}>
      <div className={`modal ${size}`} style={style} onClick={e => e.stopPropagation()}>
        <div className="modal-header">
          <h2 className="card-title">{title}</h2>
          <button className="btn btn-ghost btn-icon" onClick={onClose}><X size={18} /></button>
        </div>
        <div className="modal-body">{children}</div>
        {footer && <div className="modal-footer">{footer}</div>}
      </div>
    </div>,
    document.body
  );
}
